import {
  exists,
  GetPatrolDaysRequest,
  GetPatrolDaysRequestToJSON,
  HTTPQuery,
  UpdatePatrolDaysRequest,
  UpdatePatrolDaysRequestToJSON
} from '@/api'
import { dateToPlainFormat } from '@/utils'
import * as runtime from '../runtime'

export class PatrolDayApi extends runtime.BaseAPI {
  /**
   * 巡回日を取得する
   * @param request
   */
  async getPatrolDays(request: GetPatrolDaysRequest): Promise<string[]> {
    const queryParameters: runtime.HTTPQuery = Object.fromEntries(
      Object.entries(GetPatrolDaysRequestToJSON(request)).filter(
        value => value[1] !== undefined
      )
    ) as HTTPQuery
    const response = await this.requestGet('/patrol-days', queryParameters)

    return new runtime.JSONApiResponse(response, jsonValue =>
      exists(jsonValue, 'days') ? jsonValue.days.map(dateToPlainFormat) : []
    ).value()
  }

  /**
   * 巡回日を更新する
   * 巡回日更新
   */
  async updatePatrolDays(
    request: UpdatePatrolDaysRequest
  ): Promise<runtime.VoidApiResponse> {
    const bodyParameters: runtime.HTTPBody = UpdatePatrolDaysRequestToJSON(
      request
    )
    const response = await this.requestPut('/patrol-days', bodyParameters)

    return new runtime.VoidApiResponse(response)
  }
}
